<template>
  <section
    class="loader-wrapper"
    :style="{ background: $root.color_schema.primary }"
  >
    <template v-if="$root.custom_loader && $root.custom_loader != ''">
      <!--<img class="desaturate" :src="$root.custom_loader" />-->
      <div class="img-container">
        <img :src="$root.custom_loader" width="100" class="bottom" />
        <div class="top-img-holder">
          <img :src="$root.custom_loader" width="100" class="top" />
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="loader"
        :style="{ '--primary-color': $root.color_schema.primary }"
      >
        {{ $root.i18n.loading }}...
      </div>
    </template>
    <h3 class="custom-font-1">{{ $root.i18n.loading }}...</h3>
  </section>
</template>

<script>
export default {
  name: "LoadingSpinner",
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.loader-wrapper {
  position: fixed;
  z-index: 999999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  min-height: 360px;
  background: #070438;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h3 {
    color: #ffffff;
    text-align: center;
  }
}

.loader {
  border-radius: 50%;
  color: #ffffff;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  &:before,
  &:after {
    border-radius: 50%;
    position: absolute;
    content: "";
  }
  &:before {
    width: 5.2em;
    height: 10.2em;
    background: var(--primary-color);
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.1em 5.1em;
    transform-origin: 5.1em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  &:after {
    width: 5.3em;
    height: 10.2em;
    background: var(--primary-color);
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 4.9em;
    -webkit-transform-origin: 0.1em 5.1em;
    transform-origin: 0.1em 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
}

@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

// @keyframes toColor {
//   0% {
//     -webkit-filter: grayscale(100%);
//     filter: grayscale(100%);
//   }
//   25% {
//     -webkit-filter: grayscale(50%);
//     filter: grayscale(50%);
//   }
//   50% {
//     -webkit-filter: grayscale(0%);
//     filter: grayscale(0%);
//   }
//   75% {
//     -webkit-filter: grayscale(50%);
//     filter: grayscale(50%);
//   }
//   100% {
//     -webkit-filter: grayscale(100%);
//     filter: grayscale(100%);
//   }
// }

// img.desaturate {
//   animation: toColor 6s infinite ease;
//   width: 100px;
//   margin-bottom: 10px;
//   @media (min-width: @sizes[medium]) {
//     width: 100px;
//   }
// }

.img-container {
  width: 100px;
  height: auto;
  position: relative;
  margin-bottom: 15px;
  overflow: hidden;
}

.bottom {
  filter: brightness(0) invert(1);
}

.top-img-holder {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.top {
  position: absolute;
  width: 100px;
  height: 50px; /*change this*/
  object-fit: cover;
  object-position: bottom;
  bottom: 0;
  animation: loading 6s infinite linear;
}

@keyframes loading {
  0% {
    height: 0;
  }
  90% {
    height: 100%;
    opacity: 1;
  }
  100% {
    height: 100%;
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ui/LoaderSpinner.vue